/**
 * 히트맵/편성표 공용 모듈 정렬 규칙.
 *
 * 서버 cells 순서를 그대로 쓰지 않고, "가장 최근 실행의 collectorType이 csv parser 계열"인
 * 모듈을 아래 그룹으로 내린다. 히트맵과 편성표가 동일한 화면 순서를 갖도록 이 규칙을 공유한다.
 */

/** collectorType이 csv parser 계열인지 — 공백/구분자·대소문자 무시하고 판별. */
export const isCsvParser = (ct?: string): boolean =>
  !!ct && ct.toLowerCase().replace(/[^a-z0-9]/g, '').includes('csvparser');

/**
 * 히트맵 표시 순서로 분할: 비-csv 모듈 그룹(위) + csv parser 모듈 그룹(아래).
 * 각 그룹 내부 순서는 입력(서버 cells) 순서를 유지.
 */
export function splitByCollector<T extends { collectorType?: string }>(
  rows: T[]
): { nonCsv: T[]; csv: T[] } {
  return {
    nonCsv: rows.filter((r) => !isCsvParser(r.collectorType)),
    csv: rows.filter((r) => isCsvParser(r.collectorType)),
  };
}
